import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const btn = "h-10 px-4 rounded-xl text-sm font-semibold transition-colors";

export function FilaDialog({ open, onClose, onChange }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { if (open) { api.get("/gestao/fila").then(({ data }) => setRows(data)); } }, [open]);
  const fico = async (r) => {
    try { await api.post(`/gestao/processes/${r.pid}/fico`); toast.success(`${r.short} é teu`); setRows(rows.filter((x) => x.pid !== r.pid)); onChange(); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white max-w-lg" data-testid="fila-dialog">
        <DialogHeader><DialogTitle>Ir buscar processos</DialogTitle></DialogHeader>
        {!rows && <p className="text-[15px] text-slate-500" data-testid="fila-loading">A carregar…</p>}
        {rows && !rows.length && <p className="text-[15px] text-slate-500" data-testid="fila-empty">Não há processos sem gestor.</p>}
        <div className="divide-y divide-slate-100">
          {(rows || []).map((r) => (
            <div key={r.pid} className="flex items-center gap-3 py-3" data-testid={`fila-${r.pid}`}>
              <div className="flex-1 min-w-0">
                <Link to={`/processo/${r.pid}`} className="block text-[15px] font-semibold text-slate-900 hover:underline truncate">{r.short}</Link>
                <div className="text-sm text-slate-500">{[r.consultant, r.when].filter(Boolean).join(" · ")}</div>
              </div>
              <button onClick={() => fico(r)} className={`${btn} bg-ec-green text-white hover:bg-ec-greenDark`} data-testid={`fila-fico-${r.pid}`}>Fico com este</button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function PassarDialog({ pid, open, onClose, onDone }) {
  const [list, setList] = useState([]);
  const [pick, setPick] = useState("");
  const [note, setNote] = useState("");
  useEffect(() => { if (open) { api.get("/gestao/colegas").then(({ data }) => setList(data)); } }, [open]);
  const go = async () => {
    try { await api.post(`/gestao/processes/${pid}/passar`, { gestor_id: pick, note }); toast.success("Processo passado"); onClose(); onDone(); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white max-w-md" data-testid="passar-dialog">
        <DialogHeader><DialogTitle>Passar a um colega</DialogTitle></DialogHeader>
        <div className="space-y-2">
          {list.map((g) => (
            <button key={g.id} disabled={!!g.ausente_ate} onClick={() => setPick(g.id)} data-testid={`passar-${g.id}`}
              className={`w-full text-left px-4 py-3 rounded-xl border text-[15px] font-semibold transition-colors disabled:opacity-50 ${pick === g.id ? "bg-slate-900 text-white border-slate-900" : "bg-white border-slate-300 hover:bg-slate-50"}`}>
              {g.name}{g.ausente_ate && <span className="block text-sm font-normal">de férias até {new Date(g.ausente_ate).toLocaleDateString("pt-PT", { day: "numeric", month: "short" })}</span>}
            </button>
          ))}
          <textarea value={note} onChange={(e) => setNote(e.target.value)} placeholder="Nota para o colega (opcional)" rows={2}
            className="w-full rounded-xl border border-slate-300 px-3 py-2 text-[15px]" data-testid="passar-note" />
        </div>
        <div className="flex justify-end gap-2">
          <button onClick={onClose} className={`${btn} border border-slate-300`} data-testid="passar-cancel">Cancelar</button>
          <button disabled={!pick} onClick={go} className={`${btn} bg-ec-green text-white hover:bg-ec-greenDark disabled:opacity-40`} data-testid="passar-confirm">Passar</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
